import { useContent } from '@/hooks/useContent';

const getSteps = (t: (key: string) => string) => [
  {
    num: '1',
    icon: 'ri-message-3-line',
    title: t('how_step1_title'),
    desc: t('how_step1_desc'),
  },
  {
    num: '2',
    icon: 'ri-search-line',
    title: t('how_step2_title'),
    desc: t('how_step2_desc'),
  },
  {
    num: '3',
    icon: 'ri-tools-line',
    title: t('how_step3_title'),
    desc: t('how_step3_desc'),
  },
  {
    num: '4',
    icon: 'ri-shield-check-line',
    title: t('how_step4_title'),
    desc: t('how_step4_desc'),
  },
];

export default function HowItWorks() {
  const { t } = useContent('home');
  const steps = getSteps(t);

  return (
    <section className="py-20 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-primary-500 border border-primary-500/40 rounded-full px-4 py-1 mb-4">
          {t('how_badge')}
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-14">
          {t('how_title')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step) => (
            <div key={step.num} className="group relative bg-[#1E1E1E] border border-white/5 hover:border-primary-500/30 rounded-2xl px-6 py-8 text-center flex flex-col items-center cursor-pointer transition-all duration-300">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-primary-500 text-white text-xs font-extrabold w-6 h-6 rounded-full flex items-center justify-center">
                {step.num}
              </div>
              <div className="w-14 h-14 flex items-center justify-center rounded-full mt-2 mb-4 bg-[#2A2A2A] group-hover:bg-[#333333] transition-colors">
                <i className={`${step.icon} text-primary-500 text-2xl w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-bold text-base mb-2 text-white">{step.title}</h3>
              <p className="text-sm leading-relaxed text-[#A0A0A0]">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}